import { KeyValue } from '@angular/common';

export function getRandomNumber(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}

export function isNullOrUndefined(value: any): boolean {
  return value === null || value === undefined;
}

export function isDefined(val: any) {
  return val !== null && val !== undefined;
}

/**
 * Cut analytics tags from title string.
 * Example input: [WLC*]Highroller First Deposit 50%, output: Highroller First Deposit 50%
 * @param title
 */
export function mapBonusTitle(title: string): string {
  return (title || '')
    .replace(/\[(.*?)]/g, '')
    .replace(/\[(.*?)}/g, '')
    .replace(/\{(.*?)]/g, '')
    .replace(/\{(.*?)}/g, '')
    .replace(/_/g, ' ')
    .replace('landing', '');
}

export function fromEntries(iterable) {
  return [...iterable].reduce((obj, [key, val]) => {
    obj[key] = val;
    return obj;
  }, {});
}

export function toList(x: any): any[] {
  switch (true) {
    case x instanceof Array:
      return x;
    case typeof x === 'undefined':
      return [];
    default:
      return [x];
  }
}

export function defaults(...args) {
  return args.reverse().reduce((acc, obj) => ({...acc, ...obj}), {});
}

export function originalOrder(a: KeyValue<string, string>, b: KeyValue<string, string>): number {
  return 0;
}

export function rangeArray(start, end): number[] {
  return [...Array(end - start + 1).keys()].map((x) => x + start);
}

export const isObject = (value) => {
  return !!(value && typeof value === 'object' && !Array.isArray(value));
};

export const isArray = (value) => {
  return !!(value && Array.isArray(value));
};

export const isString = (value) => {
  return !!(value && typeof value === 'string');
};

export const isNumber = (value) => {
  return !!(value && typeof value === 'number');
};

export const isBoolean = (value) => {
  return !!(value && typeof value === 'boolean');
};

/**
 * Convert object to query string params for url
 * @param obj
 * @private
 */
export function objToQueryString(obj) {
  const keyValuePairs = Object.entries(obj).map(([key, value]) => {
    if (isArray(value)) {
      value = (value as any[]).join(',');
    }
    return `${ key }=${ encodeURIComponent(value as any) }`;
  });
  return keyValuePairs.join('&');
}

export function decodeHexStr(str: string) {
  const byteArray = new Uint8Array(str.match(/[\da-f]{2}/gi).map((h: string) => parseInt(h, 16)));
  const decodedString = new TextDecoder().decode(byteArray);
  return JSON.parse(decodedString);
}

export function isHexString(str: string): boolean {
  return /^[0-9a-fA-F]+$/i.test(str);
}



/**
 * Encode object string to hex string
 * example {regulation: "Curacao"} => 772828137213
 * @param jsonString
 * @private
 */
export function encodeToHex(jsonString: string) {
  let result = '';
  for (let i = 0; i < jsonString.length; i++) {
    result += jsonString.charCodeAt(i).toString(16);
  }
  return result;
}

export function encodeToBase64(jsonString: string) {
  return btoa(unescape(encodeURIComponent(jsonString)));
}

export function convertDobFormat(date: string) {
  if (date) {
    const parts = date.split('/');
    const day = parts[0];
    const month = parts[1];
    const year = parts[2];
    return `${year}-${month}-${day}`;
  }
}


export function decodeHex(jsonString: string) {
  let res = '';
  for (let i = 0; i < jsonString.length; i += 2) {
    res += String.fromCharCode(parseInt(jsonString.substr(i, 2), 16));
  }
  return res;
}
export function decodeFromBase64(jsonString: string): string | null {
  try {
    return decodeURIComponent(escape(atob(jsonString)));
  } catch (error) {
    console.error('Failed to decode base64 string:', error);
    return null;
  }
}

export function decodeFromHex(hexString: string) {
  let result = '';
  for (let i = 0; i < hexString.length; i += 2) {
    result += String.fromCharCode(parseInt(hexString.substr(i, 2), 16));
  }
  return result;
}

export function removeDuplicatesInObjects(array, property) {
  const uniqueIds = [];

  const unique = array.filter(element => {
    const isDuplicate = uniqueIds.includes(element[property]);

    if (!isDuplicate) {
      uniqueIds.push(element[property]);

      return true;
    }

    return false;
  });

  return unique;
}

export function decoder(arr, indices) {
  return indices.reduce(function(previousValue, currentValue){
    return previousValue + arr[currentValue];
  }, '');
}
